<app-main-navbar [wipperozLogo]="wipperozLogo" [navbarClass]="'navbar-color-white'"></app-main-navbar>
<div class="wipperoz-main-banner" [ngStyle]="{ 'background-image': 'url(' + bannerBGImage + ')' }">
  <div class="container">
    <div class="wipperoz-main-content">
      <h1 i18n="@@unsubscribeTitle">Unsubscribe from emails</h1>
      <h2 *ngIf="!working">{{ confirmationText }}</h2>
    </div>
  </div>
  <app-wip-steps></app-wip-steps>
</div>
<app-wipperoz-services></app-wipperoz-services>
<app-recent-blog-articles></app-recent-blog-articles>
<div class="footer">
  <app-footer [showGoogle]="false"></app-footer>
</div>
